// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import Box from './Box.js';
import Controller from './Controller.js';

type Props = {|
  anchor: ?HTMLElement,
  children?: React.Node,
  idealDirection?: 'up' | 'right' | 'down' | 'left',
  onDismiss: () => void,
  positionRelativeToAnchor?: boolean,
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' /* default md */,
|};

export default function Tooltip(props: Props) {
  const {
    anchor,
    children,
    idealDirection,
    onDismiss,
    positionRelativeToAnchor = true,
    size = 'md',
  } = props;

  if (!anchor) {
    return null;
  }

  return (
    <Controller
      anchor={anchor}
      bgColor="darkGray"
      idealDirection={idealDirection}
      positionRelativeToAnchor={positionRelativeToAnchor}
      onDismiss={onDismiss}
      size={size}
    >
      <Box column={12} padding={3}>
        {children}
      </Box>
    </Controller>
  );
}

Tooltip.propTypes = {
  anchor: PropTypes.shape({
    contains: PropTypes.func,
    getBoundingClientRect: PropTypes.func,
  }),
  children: PropTypes.node,
  idealDirection: PropTypes.oneOf(['up', 'right', 'down', 'left']),
  onDismiss: PropTypes.func.isRequired,
  positionRelativeToAnchor: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
};
